//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { logToSentry } from "utils/networkErrorUtils";
import { updateUI } from 'store/UI/actions';

export const sendInvitationEmail = async (data) => {
  try {
    return apis.post('emailService', '/parent_invitation', {
      body: data,
    });
  } catch (error) {
    if (error && error.message != 'Network Error') {
      logToSentry({
                message: 'sending invitation email',
                error,
                module: 'EMAIL',
                operation: 'SEND_INVITATION_EMAIL'
            });
    }
    return { error };
  }
};

export const getParentStudents = (data) => async (dispatch) => {
  try {
    const result = await apis.post('emailService', '/getParentStudents', {
      body: data,
    });
    if(result?.data){
      dispatch(updateUI({ parentStudents: result?.data }));
    }else{
      dispatch(updateUI({ parentStudents: [] }));
    }
    return result;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      logToSentry({
                message: 'sending invitation email',
                error,
                module: 'EMAIL',
                operation: 'SEND_INVITATION_EMAIL'
            });
    }
    return { error };
  }
};

export const handleGetParentByStudentId = (data) => async (dispatch) => {
  try {
    const result = await apis.post('emailService', '/parentByStudentId', {
      body: {
        student_id: data,
      },
    });
    if(result?.data){
      return result?.data;
    }else{
      return null;
    }
  } catch (error) {
    if (error && error.message != 'Network Error') {
      logToSentry({
                message: 'sending invitation email',
                error,
                module: 'EMAIL',
                operation: 'SEND_INVITATION_EMAIL'
            });
    }
    return null;
  }
};
